import { defineComponent as Z, openBlock as o, createElementBlock as e, mergeProps as p, unref as a, renderSlot as i, createElementVNode as l, createCommentVNode as u } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, g = { key: 1 }, V = { key: 2 }, H = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconStopCircle"
}, y = /* @__PURE__ */ Z({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: m, weight: n } = h(s);
    return (d, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(m)), [
      i(d.$slots, "default"),
      a(n) === "bold" ? (o(), e("g", A, t[0] || (t[0] = [
        l("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm40-112v56a12,12,0,0,1-12,12H100a12,12,0,0,1-12-12V100a12,12,0,0,1,12-12h56A12,12,0,0,1,168,100Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (o(), e("g", g, t[1] || (t[1] = [
        l("path", {
          d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm32,128H96V96h64Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM160,88H96a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V96A8,8,0,0,0,160,88Zm-8,64H104V104h48Z" }, null, -1)
      ]))) : a(n) === "fill" ? (o(), e("g", V, t[2] || (t[2] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm32,132a4,4,0,0,1-4,4H100a4,4,0,0,1-4-4V100a4,4,0,0,1,4-4h56a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : a(n) === "light" ? (o(), e("g", H, t[3] || (t[3] = [
        l("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218ZM160,90H96a6,6,0,0,0-6,6v64a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V96A6,6,0,0,0,160,90Zm-6,64H102V102h52Z" }, null, -1)
      ]))) : a(n) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM160,88H96a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V96A8,8,0,0,0,160,88Zm-8,64H104V104h48Z" }, null, -1)
      ]))) : a(n) === "thin" ? (o(), e("g", f, t[5] || (t[5] = [
        l("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220ZM160,92H96a4,4,0,0,0-4,4v64a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V96A4,4,0,0,0,160,92Zm-4,64H100V100h56Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  y as default
};
